/**
 * Personality Dimension Icons
 *
 * Maps dimension IDs to their corresponding icon names.
 */

export const DimensionIcons = {
  10: "Extraversion",
  20: "Agreeableness",
  30: "Conscientiousness",
  40: "EmotionalRange",
  50: "Openness",
} as const;

export type DimensionId = keyof typeof DimensionIcons;
export type DimensionIcon = (typeof DimensionIcons)[DimensionId];
